const input = {
    username: 'Utilizador',
    password: 'Palavra-passe',
    email: 'Email',
    phone_number: 'Telefone',
    confirm_password: 'Confirmar palavra-passe',
    search_region_code: 'Procurar código de região',
    backup_code: 'Código de backup',
    code: 'Código',
    label_with_optional: '{{label}} (Opcional)',
    email_address: 'Endereço de e-mail',
    email_placeholder: 'Introduza o seu e-mail',
    enter_email: 'Introduza o e-mail',
};
export default Object.freeze(input);
